import { useQuery } from '@apollo/client';
import { GET_DASHBOARD_NEW_COMPANIES } from '@gql/alerts';

export const useGetDashboardNewCompanies = (date?: Date, limit = 10) => {
    const { data, loading, error, refetch } = useQuery(GET_DASHBOARD_NEW_COMPANIES, {
        variables: { limit, ...(date && { date }) },
        notifyOnNetworkStatusChange: true,
    });

    return {
        companies: data?.getDashboardNewCompanies ?? [],
        loading,
        error,
        refetch,
    };
};
